// sgettext = Svelte gettext
export let sgettext = (text) => {
  if (gettext) {
    return gettext(text);
  } else {
    return text;
  }
};
